import React from 'react';
import { Link } from 'react-router-dom';

const IntroSection = () => {
  return (
    <section id="technology" className="py-32 px-6 bg-white relative overflow-hidden">
      {/* Premium background accent */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-teal-50/30 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left: Enhanced messaging */}
          <div className="space-y-8 animate-slide-in-left">
            {/* Section label */}
            <div className="inline-block">
              <span className="text-teal-500 font-medium text-sm tracking-wider uppercase">Revolutionary Science</span>
            </div>
            
            {/* Powerful headline */}
            <h2 className="text-5xl md:text-6xl font-light text-gray-900 leading-tight" style={{ fontFamily: 'Raleway, sans-serif' }}>
              The Future of
              <br />
              <span className="font-normal text-teal-500">Regenerative Medicine</span>
            </h2>
            
            {/* Compelling copy with better hierarchy */}
            <div className="space-y-6 text-lg text-gray-600 font-light leading-relaxed">
              <p className="text-xl text-gray-700">
                Meta Cell Technology represents a paradigm shift in regenerative medicine. Our proprietary photothermal biomodulation system optimizes autologous products including PRP and stem cell concentrates while simultaneously activating endogenous exosome production.
              </p>
              
              <p>
                By harnessing advanced electromagnetic energy and precision thermal conditioning, the MCT System delivers pharmaceutical-grade regenerative outcomes through natural physiological processes, ensuring superior efficacy and patient safety.
              </p>
            </div>

            {/* Premium stats */}
            <div className="pt-8 border-t border-gray-200 space-y-3">
              <p className="text-xl font-light text-teal-600">
                Produces 299.3 billion exosomes per mL
              </p>
              <p className="text-xl font-light text-teal-600">
                and 3 times more growth factors
              </p>
            </div>
          </div>

          {/* Right: Premium visual with video */}
          <div className="relative animate-slide-in-right">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover"
              >
                <source src="https://customer-assets.emergentagent.com/job_celltech-showcase/artifacts/8owbz9po_MCT%20Kit%20Render.mp4" type="video/mp4" />
              </video>
            </div>
            
            {/* Decorative accent */}
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-gradient-to-br from-teal-100/40 to-teal-200/20 rounded-full blur-3xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;